import { AppUser } from 'store/ducks/users/types';

/*
 * Action Types
 */
export enum TransportCardsTypes {
  LIST_TRANSPORT_CARDS_REQUEST = '@transportCards/LIST_TRANSPORT_CARDS_REQUEST',
  LIST_TRANSPORT_CARDS_SUCCESS = '@transportCards/LIST_TRANSPORT_CARDS_SUCCESS',
  LIST_TRANSPORT_CARDS_FAILURE = '@transportCards/LIST_TRANSPORT_CARDS_FAILURE',

  GET_TRANSPORT_CARD_REQUEST = '@transportCards/GET_TRANSPORT_CARD_REQUEST',
  GET_TRANSPORT_CARD_SUCCESS = '@transportCards/GET_TRANSPORT_CARD_SUCCESS',
  GET_TRANSPORT_CARD_FAILURE = '@transportCards/GET_TRANSPORT_CARD_FAILURE',

  FILTER_TRANSPORT_CARD_REQUEST = '@transportCards/FILTER_TRANSPORT_CARD_REQUEST',
  FILTER_TRANSPORT_CARD_SUCCESS = '@transportCards/FILTER_TRANSPORT_CARD_SUCCESS',
  FILTER_TRANSPORT_CARD_FAILURE = '@transportCards/FILTER_TRANSPORT_CARD_FAILURE',

  GET_TRANSPORT_CARD_FROM_NUMBER_REQUEST = '@transportCards/GET_TRANSPORT_CARD_FROM_NUMBER_REQUEST',
  GET_TRANSPORT_CARD_FROM_NUMBER_SUCCESS = '@transportCards/GET_TRANSPORT_CARD_FROM_NUMBER_SUCCESS',
  GET_TRANSPORT_CARD_FROM_NUMBER_FAILURE = '@transportCards/GET_TRANSPORT_CARD_FROM_NUMBER_FAILURE',

  CREATE_TRANSPORT_CARD_REQUEST = '@transportCards/CREATE_TRANSPORT_CARD_REQUEST',
  CREATE_TRANSPORT_CARD_SUCCESS = '@transportCards/CREATE_TRANSPORT_CARD_SUCCESS',
  CREATE_TRANSPORT_CARD_FAILURE = '@transportCards/CREATE_TRANSPORT_CARD_FAILURE',

  CREATE_TRANSPORT_CARDS_REQUEST = '@transportCards/CREATE_TRANSPORT_CARDS_REQUEST',
  CREATE_TRANSPORT_CARDS_SUCCESS = '@transportCards/CREATE_TRANSPORT_CARDS_SUCCESS',
  CREATE_TRANSPORT_CARDS_FAILURE = '@transportCards/CREATE_TRANSPORT_CARDS_FAILURE',

  ACTIVE_DEVICE_REQUEST = '@transportCards/ACTIVE_DEVICE_REQUEST',
  ACTIVE_DEVICE_SUCCESS = '@transportCards/ACTIVE_DEVICE_SUCCESS',
  ACTIVE_DEVICE_FAILURE = '@transportCards/ACTIVE_DEVICE_FAILURE',

  UPDATE_TRANSPORT_CARD_REQUEST = '@transportCards/UPDATE_TRANSPORT_CARD_REQUEST',
  UPDATE_TRANSPORT_CARD_SUCCESS = '@transportCards/UPDATE_TRANSPORT_CARD_SUCCESS',
  UPDATE_TRANSPORT_CARD_FAILURE = '@transportCards/UPDATE_TRANSPORT_CARD_FAILURE',

  UPDATE_TRANSPORT_CARD_STATUS_REQUEST = '@transportCards/UPDATE_TRANSPORT_CARD_STATUS_REQUEST',
  UPDATE_TRANSPORT_CARD_STATUS_SUCCESS = '@transportCards/UPDATE_TRANSPORT_CARD_STATUS_SUCCESS',
  UPDATE_TRANSPORT_CARD_STATUS_FAILURE = '@transportCards/UPDATE_TRANSPORT_CARD_STATUS_FAILURE',

  DELETE_TRANSPORT_CARD_REQUEST = '@transportCards/DELETE_TRANSPORT_CARD_REQUEST',
  DELETE_TRANSPORT_CARD_SUCCESS = '@transportCards/DELETE_TRANSPORT_CARD_SUCCESS',
  DELETE_TRANSPORT_CARD_FAILURE = '@transportCards/DELETE_TRANSPORT_CARD_FAILURE',

  REQUEST_TRANSPORT_CARD_REQUEST = '@transportCards/REQUEST_TRANSPORT_CARD_REQUEST',
  REQUEST_TRANSPORT_CARD_SUCCESS = '@transportCards/REQUEST_TRANSPORT_CARD_SUCCESS',
  REQUEST_TRANSPORT_CARD_FAILURE = '@transportCards/REQUEST_TRANSPORT_CARD_FAILURE',

  ACTIVATE_TRANSPORT_CARD_REQUEST = '@transportCards/ACTIVATE_TRANSPORT_CARD_REQUEST',
  ACTIVATE_TRANSPORT_CARD_SUCCESS = '@transportCards/ACTIVATE_TRANSPORT_CARD_SUCCESS',
  ACTIVATE_TRANSPORT_CARD_FAILURE = '@transportCards/ACTIVATE_TRANSPORT_CARD_FAILURE',

  ASSIGN_TRANSPORT_CARD_REQUEST = '@transportCards/ASSIGN_TRANSPORT_CARD_REQUEST',
  ASSIGN_TRANSPORT_CARD_SUCCESS = '@transportCards/ASSIGN_TRANSPORT_CARD_SUCCESS',
  ASSIGN_TRANSPORT_CARD_FAILURE = '@transportCards/ASSIGN_TRANSPORT_CARD_FAILURE',

  UNASSIGN_TRANSPORT_CARD_REQUEST = '@transportCards/UNASSIGN_TRANSPORT_CARD_REQUEST',
  UNASSIGN_TRANSPORT_CARD_SUCCESS = '@transportCards/UNASSIGN_TRANSPORT_CARD_SUCCESS',
  UNASSIGN_TRANSPORT_CARD_FAILURE = '@transportCards/UNASSIGN_TRANSPORT_CARD_FAILURE',

  UPDATE_TRANSPORT_CARD_SETTINGS_REQUEST = '@transportCards/UPDATE_TRANSPORT_CARD_SETTINGS_REQUEST',
  UPDATE_TRANSPORT_CARD_SETTINGS_SUCCESS = '@transportCards/UPDATE_TRANSPORT_CARD_SETTINGS_SUCCESS',
  UPDATE_TRANSPORT_CARD_SETTINGS_FAILURE = '@transportCards/UPDATE_TRANSPORT_CARD_SETTINGS_FAILURE',

  GET_TRANSPORT_CARD_SETTINGS_REQUEST = '@transportCards/GET_TRANSPORT_CARD_SETTINGS_REQUEST',
  GET_TRANSPORT_CARD_SETTINGS_SUCCESS = '@transportCards/GET_TRANSPORT_CARD_SETTINGS_SUCCESS',
  GET_TRANSPORT_CARD_SETTINGS_FAILURE = '@transportCards/GET_TRANSPORT_CARD_SETTINGS_FAILURE',
}

/*
 * Data types
 */

export interface TransportCardPlaceInterface {
  id: string;
  name: string;
  supervisorId: string;
  transportOperatorId: string;
  createdAt: string;
  updatedAt: string;
}

export interface TransportCardInterface {
  id: string;
  type: number;
  status: number;
  number: string;
  cardNumber: string | null;
  lot: string;
  userId: string;
  code: string;
  transportOperatorId: string;
  TransportCardPlace?: TransportCardPlaceInterface;
  createdAt: string;
  updatedAt: string;
  User?: AppUser | null;
  cardSettings?: {
    id: string;
    blockOld: boolean;
    createdAt: string;
    updatedAt: string;
    transportOperatorId: string;
  };
}

export interface TransportCardSettingsInterface {
  id: string;
  blockOld: boolean;
  createdAt: string;
  updatedAt: string;
  transportOperatorId: string;
}

/*
 * State type
 */
export interface TransportCardsState {
  readonly transportCardsList: TransportCardInterface[];
  readonly transportCardsListFull: TransportCardInterface[];
  readonly transportCardData: TransportCardInterface;
  readonly transportCardSettings: TransportCardSettingsInterface | null;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
